<template>
   <div class="link">
      <div class="title">
        <p5-title content="Contact" size="extra-large"></p5-title>
      </div>
      <div class="dialog">
        <div class="icon">
          <p5-icon type='party' name="alibaba" />
        </div>
        <div class="log">
          <div class="content">
            <p5-text size="large">研究室は 名古屋工業大学2号館2階大囿研究室</p5-text>
          </div>
        </div>
      </div>

      <div class="dialogImg">
        <div class="img"></div>
       </div>

      <div class="dialog">
        <div class="icon">
          <p5-icon type='party' name="alibaba" />
        </div>
        <div class="log">
          <div class="content">
            <p5-text size="large">E-mail hbq@toralab.org</p5-text>
          </div>
        </div>
      </div>

      <div class="dialog">
        <div class="icon">
          <p5-icon type='party' name="alibaba" />
        </div>
        <div class="log">
          <div class="content">
            <p5-text size="large">これは<a href="https://www.ozlab.org">研究室ホームページ</a></p5-text>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Link'
}
</script>

<style>
.link{
  margin: 220px 100px 0px 240px;
  height: calc(100% - 220px);
  width: 100%;
  overflow: auto;
}
.link .p5-svg-party {
  width: 150px;
  height: 150px;
}
.link .title{
  position: absolute;
  top: 115px;
  left: 800px;
  transform: rotate(8deg);
}
.link .dialog{
  height: 200px;
  width: 1200px;
}
.link .dialogImg{
  height: 580px;
  width: 1200px;
}
.link .text-size-extra-large {
  display: block;
  font-size: 44px;
  text-align: center;
}
.link .icon{
  float: left;
  margin: 0px -25px 0px 150px;
}
.link .log{
  float: left;
  height: 158px;
  width: 700px;
  background: url("../assets/log.png") no-repeat;
  background-size: cover;
}
.link .log .content{
  position: relative;
  top:60px;
  left: 135px;
}
.link .log .content_large{
  position: relative;
  top: 48px;
  left: 135px;
  width: 450px;
}
.link .img{
  position: relative;
  float: left;
  background: url("../assets/map.png") no-repeat;
  background-size: cover;
  width: 540px;
  height: 519px;
  top: 0px;
  left: 283px;
 }
  </style>